exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".span{color:#fff}.input,.span{font-size:30px}.input{height:40px;width:350px}", ""]);

// exports
